import { useOptionalPrivanaI18n } from '@/i18n/PrivanaI18nProvider.jsx';
import { useToast } from "@/components/ui/use-toast";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";

export function Toaster() {
  const { t } = useOptionalPrivanaI18n();
  const { toasts, dismiss } = useToast();

  return (
    <ToastProvider>
      <ToastViewport>
        {toasts.map(function ({ id, title, description, action, closeLabelKey, ...props }) {
          const handleClose = () => {
            dismiss(id);
          };

          return (
            <Toast key={id} {...props}>
              <div className="grid gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
              {action}
              <ToastClose aria-label={closeLabelKey ? t(closeLabelKey) : "Close"} onClick={handleClose} />
            </Toast>
          );
        })}
      </ToastViewport>
    </ToastProvider>
  );
}